<unity-page-container contentHeader="Programs" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>

  <ng-container notifications />

  <ng-container actions>
    <unity-action-shared [action]="createProgramAction" />
  </ng-container>

  <unity-grid-program-shared />
</unity-page-container>
